// import React, { useEffect, useState } from 'react'
// import logo from "../../assets/logo.png"
// import { Link } from 'react-router-dom';
// import { useContext } from 'react';
// import "./nav.css"
// import { AppContext } from '../../App';
// import { useNavigate } from 'react-router-dom';
// import GoogleTransTwo from '../GoogleTransTwo';




// function Nav(props) {
//   const history =useNavigate()
//   const {route}=useContext(AppContext)

//   const {login,setLogin}=useContext(AppContext)

//   const hanleSigOut =()=>{
//  history("/")
//     window.location.reload();
//     sessionStorage.clear()
//     document.querySelector(".nav .list").classList.remove("list-show")
//     setLogin(false)
//    }
// const clickBurger =()=>{
//   document.querySelector(".nav .list").classList.toggle("list-show")
// }
// const clickLink =()=>{
//   document.querySelector(".nav .list").classList.remove("list-show")
// }


//   return (
//     <div className="nav">


//     <div className="container">
//       <Link onClick={clickLink} to="/"> <img src={logo} alt="" /></Link>
//       <div className="burger" onClick={clickBurger}>
//       <input type="checkbox" onClick={clickBurger} id="checkbox" />
//     <label for="checkbox" class="toggle">
//         <div class="bars" id="bar1"></div>
//         <div class="bars" id="bar2"></div>
//         <div class="bars" id="bar3"></div>
//     </label>
//       </div>
       
//         <div className="list">

//         {/* <Link onClick={clickLink} to="/help">المساعده و الدعم</Link> */}
        
  
//       {/* {login ? <Link onClick={clickLink} to="/my-certi">شهاداتي</Link>:null}   
//      {login ? <Link onClick={clickLink} to="/profile">الاعدادات</Link>:null}    */}
//      <Link onClick={clickBurger} to="/">الرئيسية </Link>
//      {login ? <Link onClick={clickBurger} to="/products">المنتجات</Link> : null}
    
//         <a onClick={clickBurger} href='#about'>من نحن </a>
//         <a onClick={clickBurger} href='#contact'>اتصل بنا </a>
//         <a onClick={clickBurger} href="#news">الأخبار </a>
//         <Link to="activities">الفعاليات</Link>
  
//         {login ? <Link  to="/login" onClick={hanleSigOut}>تسجيل الخروج</Link> : <Link onClick={clickBurger} to="/login" >تسجل الدخول</Link> }
//         {login ? <Link onClick={clickBurger} to="/main-page" >لوحة التحكم</Link> : null }
//         <GoogleTransTwo burger={clickBurger} />
     
//             </div>
//         </div>
//     </div>
//   )
// }

// export default Nav

import React, { useState, useContext } from 'react'
import logo from "../../assets/logo.png"
import { Link, useNavigate } from 'react-router-dom'
import "./nav.css"
import { AppContext } from '../../App'
import GoogleTransTwo from '../GoogleTransTwo'

function Nav() {
  const navigate = useNavigate()
  const { login, setLogin } = useContext(AppContext)

  const [open, setOpen] = useState(false)

  const toggleMenu = () => {
    setOpen(!open)
  }

  const closeMenu = () => {
    setOpen(false)
  }

  const handleHomeClick = () => {
    closeMenu()
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  const hanleSigOut = () => {
    navigate("/")
    sessionStorage.clear()
    setLogin(false)
    closeMenu()
  }

  return (
    <nav className="nav">
      <div className="container">

        <Link to="/" onClick={closeMenu}>
          <img src={logo} alt="logo" />
        </Link>

        {/* Burger */}
        <div className={`burger ${open ? "active" : ""}`} onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>

        {/* Menu */}
        <div className={`list ${open ? "list-show" : ""}`}>

          <Link to="/" onClick={handleHomeClick}>الرئيسية</Link>
          {login ? <Link to="/products" onClick={closeMenu}> الدورات التخصصية</Link> : null}

          <Link to="/#about" onClick={closeMenu}>من نحن</Link>
          <Link to="/#contact" onClick={closeMenu}>اتصل بنا</Link>
          <Link to="/#news" onClick={closeMenu}>الأخبار</Link>

          {login ? <Link to="/activities" onClick={closeMenu}>الفعاليات</Link> : null}

          {login
            ? <Link to="/login" onClick={hanleSigOut}>تسجيل الخروج</Link>
            : <Link to="/login" onClick={closeMenu}>تسجيل الدخول</Link>
          }

          {login
            ? <Link to="/main-page" onClick={closeMenu}>لوحة التحكم</Link>
            : null
          }

          <GoogleTransTwo burger={closeMenu} />
        </div>

      </div>
    </nav>
  )
}

export default Nav
